import { Component, OnInit } from "@angular/core";
import { Router, ActivatedRoute } from "@angular/router";
import { API } from "../config/api-config";
import { CommonService } from "../service/common";
import { FileUpload } from "../service/file-upload";
import { HttpService } from "../service/http-service";
import { Location } from "@angular/common";

@Component({
  selector: "app-question-edit",
  templateUrl: "./question-edit.component.html",
  styleUrls: ["./question-edit.component.css"],
})
export class QuestionEditComponent implements OnInit {
  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private HttpService: HttpService,
    private location: Location,
    private fileupload: FileUpload,
    private common: CommonService
  ) {}

  private id: number = 0;

  public isCreate: boolean = false;

  public imagePath: string = "";

  public data: any = {
    active: 1,
    titleEn: "",
    titleTc: "",
    id: 0,
    answerEn: "",
    answerTc: "",
  };

  ngOnInit() {
    this.route.params.subscribe((params) => {
      this.id = params["id"];
      this.data.id = this.id;
    });
    if (this.id != 0) {
      this.getData();
    } else {
      this.isCreate = true;
    }
  }

  public submit(): void {
    let data = this.data;
    console.log(data);
    delete data.updatedTime;
    delete data.updatedBy;
    delete data.createdTime;
    delete data.createdBy;
    this.HttpService.postData(API.question, data).then((res) => {
      let data = res;
      if (data.status.code == 0 || data.status.code == "0") {
        this.location.back();
      } else {
        alert(data.status.message);
      }
    });
  }

  private getData(): void {
    this.HttpService.getData(API.question + "/" + this.id).then((res) => {
      this.data = res.data;
    });
  }
}



// WEBPACK FOOTER //
// /data/jenkins_data/workspace/NaturallyPlus_WEB_UAT/src/app/question-edit/question-edit.component.ts